import {
  CommonStatusStep,
  IDownLoadMenu,
  IDownLoadVersionMenu,
  IEngineItem,
} from '../../../../model/api-modules';
import { getEngineName } from './download-version-form';
import { getDownLoadItems } from '../../../../api/admin/download';
import { messageError } from '../../../../components/message';
import { useEffect, useState } from 'react';
import getFormatMessage from '../../../../locales/get-format-message';
import { AutoAntTable } from '../../../../components/auto-ant-table';
import {
  CommonButton,
  CommonButtonGroup,
} from '../../../../components/button/main';
import { ISiteIDownLoadMenu } from '../download-items';
import { ISiteIDownLoadVersionMenu } from '../download-version';
import { getSiteMatchedDownloadVersion } from './multi-site-helper';
import {
  getAntLastModifyColumn,
  getUserNameBySite,
  renderValidateStatusCell,
} from '../../lib/columns';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../../store/reducers';
import { getLocalTime, getNeedManageSites } from '../../../../lib';
import moment from 'moment';

interface IProps {
  readonly allSiteDownLoadList: ISiteIDownLoadMenu;
  readonly allSiteDownLoadVersionList: ISiteIDownLoadVersionMenu;
  readonly getDownLoadVersionList: () => void;
  readonly loading: boolean;
  readonly downLoadVersionList: IDownLoadVersionMenu[];
  readonly onView: (record: IDownLoadVersionMenu) => void;
  readonly onEdit: (record: IDownLoadVersionMenu) => void;
  readonly onCopy: (record: IDownLoadVersionMenu) => void;
  readonly onDel: (record: IDownLoadVersionMenu) => void;
  readonly selectedRowKeys: number[];
  readonly setSelectedRowKeys: (value: number[]) => void;
}

export const DownloadVersionTable = (props: IProps) => {
  const { allSiteDownLoadList, allSiteDownLoadVersionList } = props;
  const { selectedRowKeys, setSelectedRowKeys } = props;
  const [downLoadList, setDownLoadList] = useState<
    ReadonlyArray<IDownLoadMenu>
  >([]);
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);
  const getDownLoadList = async () => {
    const res = await getDownLoadItems();
    if (res) {
      setDownLoadList(res);
    } else {
      messageError(getFormatMessage('download_list_fail'));
    }
  };

  useEffect(() => {
    getDownLoadList();
  }, []);
  const renderDefaultOperate = (
    record: IDownLoadVersionMenu,
    onView: (record: IDownLoadVersionMenu) => void,
    onEdit: (record: IDownLoadVersionMenu) => void,
    onCopy: (record: IDownLoadVersionMenu) => void,
    onDel: (record: IDownLoadVersionMenu) => void
  ): React.ReactNode => {
    return (
      <CommonButtonGroup>
        <CommonButton type="link" onClick={() => onView(record)}>
          查看
        </CommonButton>

        <CommonButton type="link" onClick={() => onEdit(record)}>
          {getFormatMessage('edit')}
        </CommonButton>
        <CommonButton type="link" onClick={() => onCopy(record)}>
          {getFormatMessage('copy')}
        </CommonButton>
        <CommonButton
          type="link"
          className="ant-btn-dangerous"
          onClick={() => onDel(record)}
        >
          {getFormatMessage('delete')}
        </CommonButton>
      </CommonButtonGroup>
    );
  };

  const columns: any = [
    {
      title: getFormatMessage('name_uppercase'),
      dataIndex: 'Name',
      key: 'Name',
      render: (_text: string, record: IDownLoadVersionMenu) => {
        const matchedItem = downLoadList.find(
          (item: { id: number }) => item.id === record.ObjectID
        );
        const name = matchedItem ? matchedItem.Name : '';

        return <span>{name}</span>;
      },
    },
    {
      title: getFormatMessage('version'),
      dataIndex: 'Version',
      key: 'Version',
      sorter: (a: { Version: string }, b: { Version: string }) =>
        a.Version.localeCompare(b.Version),
    },
    {
      title: getFormatMessage('status'),
      dataIndex: 'Status',
      key: 'Status',
      render: (val: CommonStatusStep, record: IDownLoadVersionMenu) => {
        const statusMap = getNeedManageSites().reduce<
          Record<string, CommonStatusStep>
        >((acc, site) => {
          acc[site] =
            getSiteMatchedDownloadVersion(
              record,
              site,
              allSiteDownLoadList,
              allSiteDownLoadVersionList
            )?.Status || CommonStatusStep.Pending;
          return acc;
        }, {});
        return renderValidateStatusCell(statusMap);
      },
    },

    {
      title: getFormatMessage('engine'),
      dataIndex: 'EngineJson',
      key: 'EngineJson',
      render: (engineJson: ReadonlyArray<IEngineItem>) => {
        const engineName = getEngineName(engineJson);
        return <span>{engineName}</span>;
      },
    },
    getAntLastModifyColumn(
      {
        render: (_text: string, record: IDownLoadVersionMenu) => {
          const matchedRecord = [record, ...(record.SubVersions || [])].sort(
            (a, b) =>
              moment(a.ModifyTime).isBefore(moment(b.ModifyTime)) ? 1 : -1
          )[0];
          if (!matchedRecord) {
            return null;
          }

          return (
            <div>
              <div>{getLocalTime(matchedRecord.ModifyTime)}</div>
              <div>
                {getUserNameBySite(
                  matchedRecord.ModifierID || matchedRecord.CreatorID
                )}
              </div>
            </div>
          );
        },
      },
      userInfo
    ),
    {
      title: getFormatMessage('operate'),
      key: 'action',
      render: (_text: string, record: IDownLoadVersionMenu) =>
        renderDefaultOperate(
          record,
          props.onView,
          props.onEdit,
          props.onCopy,
          props.onDel
        ),
    },
  ];

  const onSelectChange = (newSelectedRowKeys: any) => {
    console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  return (
    <AutoAntTable
      className="download-table"
      loading={props.loading}
      dataSource={props.downLoadVersionList || []}
      columns={columns}
      rowSelection={{ selectedRowKeys, onChange: onSelectChange }}
      configFilter={{
        filters: [
          {
            type: 'search',
            name: 'Name',
            place: 'right',
            placeholder: '请输入名称搜索',
            filter: (search = '', record) => {
              const matchedItem = downLoadList.find(
                (item: { id: number }) => item.id === record.ObjectID
              );
              const name = matchedItem ? matchedItem.Name : '';
              return name.toLowerCase().includes(search.toLowerCase());
            },
          },
        ],
      }}
    />
  );
};
